import {UPDATE_USER} from '../../action.types'
const initialState = {
    user: null
}

const _update = (state, user) => {
    return {
        ...state,
        user
    }
}

export default (state = initialState, action) => {
    switch(action.type){
        case UPDATE_USER:
            return _update(state, action.payload)
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/user/user.reducer.js